import { FourStatePieceTriangularGameState } from '../../jscaip/state/TriangularGameState';
export class SaharaState extends FourStatePieceTriangularGameState {
}
